import * as types from '../mutation-types';

const state = {
  currentPage: {
    me: 0,
    unassigned: 0,
    all: 0,
    // SiteUp: Kanban quick-filter uses assigneeType=kanban as the page key.
    // Without an explicit 0, getCurrentPageFilter('kanban') is undefined →
    // page becomes NaN/null and every loadMore re-requests page 1 forever
    // (infinite list spinner while cards stay visible).
    kanban: 0,
    appliedFilters: 0,
  },
  hasEndReached: {
    me: false,
    unassigned: false,
    all: false,
    kanban: false,
  },
  // SiteUp: cursor da fila por espera, por aba: { page, value }. `page` é a
  // página que devolveu o cursor; ele só vale para pedir a página seguinte.
  cursor: {},
};

export const getters = {
  getHasEndReached: $state => filter => {
    return $state.hasEndReached[filter];
  },
  getCurrentPageFilter: $state => filter => {
    return $state.currentPage[filter];
  },
  getCurrentPage: $state => {
    return $state.currentPage;
  },
  getCursorFilter: $state => filter => {
    return $state.cursor?.[filter] || null;
  },
};

export const actions = {
  setCurrentPage({ commit }, { filter, page }) {
    commit(types.default.SET_CURRENT_PAGE, { filter, page });
  },
  setEndReached({ commit }, { filter }) {
    commit(types.default.SET_CONVERSATION_END_REACHED, { filter });
  },
  setCursor({ commit }, { filter, page, cursor }) {
    commit(types.default.SET_CONVERSATION_CURSOR, { filter, page, cursor });
  },
  reset({ commit }) {
    commit(types.default.CLEAR_CONVERSATION_PAGE);
  },
};

export const mutations = {
  [types.default.SET_CURRENT_PAGE]: ($state, { filter, page }) => {
    $state.currentPage = {
      ...$state.currentPage,
      [filter]: page,
    };
  },
  [types.default.SET_CONVERSATION_END_REACHED]: ($state, { filter }) => {
    if (filter === 'all') {
      $state.hasEndReached = {
        ...$state.hasEndReached,
        unassigned: true,
        me: true,
      };
    }
    $state.hasEndReached = {
      ...$state.hasEndReached,
      [filter]: true,
    };
  },
  [types.default.SET_CONVERSATION_CURSOR]: (
    $state,
    { filter, page, cursor }
  ) => {
    $state.cursor = {
      ...($state.cursor || {}),
      [filter]: cursor ? { page, value: cursor } : null,
    };
  },
  [types.default.CLEAR_CONVERSATION_PAGE]: $state => {
    $state.currentPage = {
      me: 0,
      unassigned: 0,
      all: 0,
      kanban: 0,
      appliedFilters: 0,
    };

    $state.hasEndReached = {
      me: false,
      unassigned: false,
      all: false,
      kanban: false,
      appliedFilters: false,
    };

    $state.cursor = {};
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
